import { useEffect, useState } from 'react';

import type { SpGroupType } from '@/hooks/swr/group/useSPGroups';
// Hooks
import useSocialProfiles from '@/utils/hooks/swr/useSocialProfiles';

import type { ChartSocialProfilesDisplayInfosType } from '@/utils/groups/analytics/getChartData';
// Lib
import { getChartSocialProfilesDisplayInfos } from '@/utils/groups/analytics/getChartData';

// Types
import type { SocialProfileType } from '@/types/socialProfileType';

import type { ChartType } from '@/lib/analytics/charts/type';

export type UseMostEfficientSocialProfilesDisplayInfosType = (
    mostEfficientSocialProfiles: Record<
        SpGroupType['id'],
        Record<ChartType<any>['id'], SocialProfileType['id'][]>
    >
) => {
    socialProfilesDisplayInfos: ChartSocialProfilesDisplayInfosType;
};

const useMostEfficientSocialProfilesDisplayInfos: UseMostEfficientSocialProfilesDisplayInfosType = (
    mostEfficientSocialProfiles
) => {
    const { socialProfiles } = useSocialProfiles({ revalidateIfStale: false });

    const [socialProfilesDisplayInfos, setSocialProfilesDisplayInfos] = useState({});

    useEffect(() => {
        const spToAdd = Object.keys(mostEfficientSocialProfiles ?? []).reduce(
            (accGlobal, groupId) => [
                ...accGlobal,
                ...Object.keys(mostEfficientSocialProfiles[groupId] ?? []).reduce(
                    (accPerGroup, chartId) => [
                        ...accPerGroup,
                        ...mostEfficientSocialProfiles[groupId][chartId]
                            .filter(
                                (spId) =>
                                    accPerGroup.findIndex((sp) => sp?.id === spId) < 0 &&
                                    !socialProfilesDisplayInfos[spId]
                            )
                            .map((spid) => socialProfiles.find((sp) => sp?.id === spid))
                    ],
                    []
                )
            ],
            []
        );

        if (spToAdd.length > 0) {
            setSocialProfilesDisplayInfos((prevState) => ({
                ...prevState,
                ...getChartSocialProfilesDisplayInfos(spToAdd)
            }));
        }
    }, [mostEfficientSocialProfiles]);

    return { socialProfilesDisplayInfos };
};

export default useMostEfficientSocialProfilesDisplayInfos;
